<script lang="ts">
  import NavigatorLinkWrapper from "../common/link/NavigatorLinkWrapper.svelte";
  import Icon from "../common/icons/Icon.svelte";
  import LoginButton from "./LoginButton.svelte";
  import checkMobileDevice from "../common/is-mobile";
  import pageUrl from "../../PageUrl";

  export let isActive: boolean = false;

  const isMobile = checkMobileDevice();
  const navLinkProps = {
    textColor: "#a7b0b5",
    activeTextColor: "#0e0121",
    hoverTextColor: "#0e012180",
    disableTextColor: "rgba(255, 255, 255, 0.25)",
    underlineOnHover: true,
  };
</script>

<header
  class="main-header-container"
  class:active={isActive}
  class:mobile={isMobile}
>
  <div class="main-header-bg">
    <div class="header">
      <div class="top-navigation-logo">
        <a href={pageUrl.HOME}>
          {#if isMobile}
            <Icon icon="datadocs-logo" size="36px" />
          {:else}
            <Icon icon="datadocs-logo-home" width="137px" height="28px" />
          {/if}
        </a>
      </div>

      <div class="top-navigation-main">
        <nav class="main-nav">
          <ul class="main-menu">
            <li>
              <NavigatorLinkWrapper to={pageUrl.HOME} {...navLinkProps}
                >Home</NavigatorLinkWrapper
              >
            </li>
            <li>
              <NavigatorLinkWrapper to={pageUrl.BLOG} {...navLinkProps}
                >Blog</NavigatorLinkWrapper
              >
            </li>
            <li>
              <NavigatorLinkWrapper to={pageUrl.CAREERS} {...navLinkProps}
                >Careers</NavigatorLinkWrapper
              >
            </li>
          </ul>
        </nav>

        {#if !isMobile}
          <LoginButton {isMobile} />
        {/if}
      </div>

      {#if isMobile}
        <LoginButton {isMobile} />
      {/if}
    </div>
  </div>
</header>

<style lang="postcss">
  .main-header-container {
    position: sticky;
    position: -webkit-sticky;
    top: 0px;
    z-index: 1000;
  }

  .main-header-container.active {
    @apply bg-white;
  }

  .main-header-bg {
    @apply w-full px-10 py-4;
    font-size: 13px;
    height: 68px;
    transition: box-shadow 0.2s ease-in-out;
  }

  .active .main-header-bg {
    @apply bg-primary-datadocs-blue bg-opacity-10;
    box-shadow: 1px 4px 6px rgba(55, 84, 170, 0.16);
  }

  .mobile .main-header-bg {
    @apply px-4;
    font-size: 11px;
  }

  .header {
    @apply flex flex-row items-center h-full w-full justify-between;
    max-width: var(--splash-page-max-width);
    margin: 0px auto;
  }

  .top-navigation-main {
    @apply flex flex-row items-center;
  }

  ul {
    @apply flex flex-row items-center space-x-8 mr-10;
  }

  .mobile ul {
    @apply space-x-3.5 mr-0;
  }

  li {
    @apply relative box-border list-item uppercase;
  }

  @media (max-width: 600px) {
    ul {
      @apply space-x-3.5 mr-4;
    }
  }
</style>
